export default {
  'reset': 'Start på nytt',
  'next': 'Neste',
  'loading': 'Laster...',
  'logout': 'Logg ut',
  'back': 'Tilbake',
  'save': 'Lagre',
  'cancel': 'Avbryt',
  'error': 'Noe gikk galt!',
  'jumpToContent': 'Hopp til hovedinnhold',
  'help': 'Hjelp',
  'resource': 'Ressurs',
  'resourceCenter': 'Åpne hjelpesenter',
  'close': 'Lukk',
  'download': 'Last ned',
  'recommendedContent': 'Foreslått innhold',
  'remove': 'Fjern',
  'unknownError': 'Noe gikk galt dessverre. Prøv igjen senere.',
  'relatedContent': 'Relatert innhold',
  'new': 'Nytt',
  'login': {
    'brand': 'Aschehoug univers',
    'slogan': 'Med læreren. For eleven.',
    'title': 'Logg inn',
    'welcome': 'Velkommen til Aschehoug univers',
    'intro': 'For å se læremidlene må du logge inn',
    'withServiceProvider': 'Med Feide',
    'withLocalProvider': 'Uten Feide',
    'logout': 'Logg ut',
    'news': 'Aktuelt',
  },
  'time': {
    'week': 'Uke',
    'weekWithNumber': 'Uke {number}',
  },
  'http': {
    '404': {
      'code': '404',
      'message': 'Ikke funnet',
    },
  },
  'notFound': {
    'title': 'Finnes ikke',
    'heading': 'Ooops!',
    'message': 'Innholdet kan være fjernet, eller du kan mangle tilgang.',
    'buttonText': 'Tilbake til forsiden',
    'statusCode': 'Statuskode: 404',
  },
  'calendar': {
    'title': 'Kalender',
    'messages': {
      'noResults': 'Ingen resultater',
      'noResultsInWeekSwitcher': {
        'message': 'Ingen oppgaver planlagt i uke {number} for {grade}',
        'solution': 'Prøv å bytte gruppe, trinn eller uke. Legg til ved å trykke på \'Se flere oppgaver\'',
      },
      'noResultsDescription': 'Fant ingen uker med innhold i valgt periode',
      'noWeekResources': 'Fant ingen ressurser denne uken',
      'noResourcesInPeriod': 'Fant ingen ressurser i valgt periode.',
      'periodUpdated': 'Periode oppdatert',
      'periodUpdateError': 'Kunne ikke oppdatere periode',
      'periodCreated': 'Periode opprettet',
      'periodCreateError': 'Kunne ikke opprette periode',
    },
    'updatePlan': {
      'titlePlaceholder': 'Tittel',
      'bodyPlaceholder': 'Beskrivelse',
      'dialogTitle': 'Rediger periode',
      'save': 'Lagre',
      'change': 'Rediger',
      'cancel': 'Avbryt',
      'delete': 'Slett',
    },
    'createPeriod': {
      'titlePlaceholder': 'Tittel',
      'bodyPlaceholder': 'Beskrivelse',
      'new': 'Ny periode',
      'dialogTitle': 'Opprett periode',
      'startWeek': 'Start-uke',
      'endWeek': 'Slutt-uke',
      'create': 'Opprett',
      'abort': 'Avbryt',
      'delete': 'Slett',
    },
    'note': {
      'teacher': 'Skriv notat',
      'studentShow': 'Se notat fra lærer',
      'studentHide': 'Skjul notat fra lærer',
    },
    'yearPlan': {
      'sharedYearPlans': 'Kollegers planer',
    },
    'errors': {
      'loadYearPlans': 'Noe gikk galt ved lasting av årsplaner',
      'loadSharedYearPlans': 'Noe gikk galt ved lasting av foreslåtte årsplaner',
      'loadPlans': 'Noe gikk galt ved lasting av planer',
    },
  },
  'groups': {
    'active': 'Aktiv',
    'activeTitle': 'Aktiv gruppe',
    'title': 'Ingen klasse valgt | {count} klasser valgt',
    'dialogBody': 'Velg hvilket fag gruppen undervises i.',
    'missingSubject': 'Gruppen mangler et tilkoblet fag',
    'readOnlyBody': 'Gruppen er koblet til {grade}. For å endre, ta kontakt med {admins}',
    'noGrades': 'Ingen trinn funnet',
    'noSubjects': 'Ingen fag funnet',
    'saveGroup': 'Lagre gruppe',
    'editGroup': 'Rediger gruppe',
    'deleteGroup': 'Slett gruppe',
    'newGroup': 'Ny gruppe',
    'noGroup': 'Mangler aktiv gruppe',
    'chooseGroup': 'Velg en aktiv gruppe i toppmenyen for å se planlagte ressurser.',
    'cancel': 'Avbryt',
    'noSave': 'Gå til fagside',
    'saveError': 'Feil ved lagring av gruppe',
    'saveSuccess': 'Gruppen ble lagret',
    'nonWriteable': 'Grupper fra Feide kan ikke redigeres i Aunivers',
    'nonAdminGroup': 'For å endre på gruppen må du ta kontakt med en administrator',
    'nonAdminContact': 'For å endre på gruppen må du ta kontakt med {admins}',
    'membersCount': '{count} medlemmer',
    'members': 'Medlemmer',
    'addMember': 'Legg til medlem i gruppen',
    'addMemberShort': 'Legg til',
    'removeMember': 'Fjern medlem fra gruppen',
    'grade': 'Trinn',
    'groupName': 'Gruppenavn',
    'types': {
      'basis': 'Klasser (Hentet fra Feide)',
      'teaching': 'Undervisningsgrupper',
      'other': 'Grupper (Laget i Aunivers)',
    },
    'userSearch': {
      'search': 'Søk etter brukere',
      'searching': 'Søker...',
      'noResults': 'Ingen resultater',
    },
    'groupDeleted': 'Gruppen ble slettet',
    'groupDeleteError': 'Feil ved sletting av gruppe',
    'noGradesConnected': 'Ingen tilkoblede trinn eller fag',
    'admin': 'Admin',
    'groupDeleteConfirm': 'Er du sikker på at du vil slette denne gruppen?',
    'groupNamePlaceholder': 'Skriv gruppenavn...',
    'noLocalGroups': 'Du har ingen Aunivers grupper enda. <br> Trykk på "Ny gruppe" for å lage en.',
    'noGroups': 'Du har ingen klasser eller grupper tilkoblet til bruker. Begynn å lage grupper enten i Feide eller ved å trykke "Opprett ny gruppe" nedenfor.',
    'noGroupsTitle': 'Mangler grupper',
    'copyGroup': 'Kopier gruppe',
    'copyOf': '{groupName} (kopi)',
  },
  'header': {
    'chooseGroup': 'Velg gruppe',
  },
  'settings': {
    'title': 'Innstillinger',
    'roleTeacher': 'Lærer hos',
    'roleStudent': 'Elev ved',
    'roleAtOrganization': '{role} {organization}',
    'updated': 'Innstillinger lagret!',
    'activeGroup': 'Du har en aktiv gruppe ({groupName})',
    'missingGrade': 'Gruppen din mangler et tilkoblet trinn',
    'missingSubject': 'Gruppen din mangler et tilkoblet fag',
    'changeSubjectInfo': 'Du kan fortsatt redigere hvilke fag du vil ha synlig på forsiden!',
    'groupInfo': 'Grupper gjør det enklere å navigere riktig innhold! Derfor krysser vi automatisk av på innstillingene nedenfor basert på trinn og fag koblet til din gruppe',
    'chooseGrade': 'Velg trinn for å se relaterte fag',
    'chooseGradeToClose': 'Du må velge et trinn',
    'sections': {
      'display': 'Visningsvalg',
      'instruction': 'Undervisning',
      'tts': 'Talesyntese',
    },
    'drawers': {
      'customization': 'Trinn og fag',
      'language': 'Språk',
      'groups': 'Klasser og grupper',
      'plans': 'Foreslåtte planer',
      'licenses': 'Lisenser',
      'shortcuts': 'Snarveier',
    },
    'shortcuts': {
      'digitalBooks': 'Unibok - Digitale bøker',
      'teacherGuides':  'Lærerveiledning til bøkene (1-10)',
    },
  },
  'wizard': {
    'warningTitle': 'Vent litt!',
    'warningText': 'Velg både trinn og fag før du lukker vinduet.',
    'nextStep': 'Neste',
    'prevStep': 'Forrige',
    'step': 'Steg {activeStep} av {steps}',
    'finish': 'Fullfør',
    'grades': 'Velg trinn du underviser på',
    'subjects': 'Hvilke fag ønsker du å se?',
    'language': 'Velg foretrukket målform',
  },
  'licenses': {
    'title': 'Lisenser',
  },
  'home': {
    'title': 'Hjem',
    'welcome': 'Velkommen til Aschehoug univers!',
    'yourSubjects': 'Dine fag',
    'yourAddons': 'Dine tilleggsprodukter',
    'showMoreSubjects': 'Vis flere fag',
    'showLessSubjects': 'Vis færre fag',
    'showMoreProducts': 'Vis flere produkter',
    'showLessProducts': 'Vis færre produkter',
    'highSchoolProducts': 'VGS-produkter',
    'greetings': {
      'morning': 'God morgen',
      'afternoon': 'God ettermiddag',
      'evening': 'God kveld',
      'night': 'God natt',
    },
  },
  'notifications': {
    'title': 'Varsler',
    'notification': 'Varsel',
    'today': 'I dag',
    'thisWeek': 'Siste syv dager',
    'markRead': 'Marker som lest',
    'markAllRead': 'Marker alle som lest',
    'allNotifications': 'Alle varsler',
    'allNotificationsMarkedAsRead': 'Alle varsler ble markert som lest',
    'sentNotifications': 'Sendte varsler',
    'receivedNotifications': 'Mottatte varsler',
    'noNotifications': 'Hurra! Du har ingen nye varsler',
    'noReceivedNotifications': 'Du har ingen nye mottatte varsler',
    'noSentNotifications': 'Du har ikke sendt varsler nylig',
    'chooseNotificationType': 'Velg type varsel',
    'viewAll': 'Se alle',
    'goToResource': 'Gå til ressurs',
    'received': 'Mottatt',
    'sent': 'Sendt',
  },
  'metadata': {
    'weekdays': {
      'monday': 'Mandag',
      'tuesday': 'Tirsdag',
      'wednesday': 'Onsdag',
      'thursday': 'Torsdag',
      'friday': 'Fredag',
      'saturday': 'Lørdag',
      'sunday': 'Søndag',
    },
    'grades': {
      'aarstrinn1': 'Trinn 1',
      'aarstrinn2': 'Trinn 2',
      'aarstrinn3': 'Trinn 3',
      'aarstrinn4': 'Trinn 4',
      'aarstrinn5': 'Trinn 5',
      'aarstrinn6': 'Trinn 6',
      'aarstrinn7': 'Trinn 7',
      'aarstrinn8': 'Trinn 8',
      'aarstrinn9': 'Trinn 9',
      'aarstrinn10': 'Trinn 10',
      'vg1': 'Vg1',
      'vg2': 'Vg2',
      'vg3': 'Vg3',
      'vok': 'Voksen',
      'prep': 'Forkurs',
    },
    'gradesPunctuated': {
      'aarstrinn1': '1. trinn',
      'aarstrinn2': '2. trinn',
      'aarstrinn3': '3. trinn',
      'aarstrinn4': '4. trinn',
      'aarstrinn5': '5. trinn',
      'aarstrinn6': '6. trinn',
      'aarstrinn7': '7. trinn',
      'aarstrinn8': '8. trinn',
      'aarstrinn9': '9. trinn',
      'aarstrinn10': '10. trinn',
    },
    'subjects': {
      'ENG': 'Engelsk',
      'FSP': 'Fremmedspråk',
      'KRO': 'Kroppsøving',
      'MAT': 'Matematikk',
      'NAT': 'Naturfag',
      'FLE': 'Flerfaglig',
      'NOR': 'Norsk',
      'SAF': 'Samfunnsfag',
      'FYS': 'Fysikk',
      'GEO': 'Geografi',
      'HEL': 'Helse',
      'HIS': 'Historie',
      'KJE': 'Kjemi',
      'MED': 'Mediefag',
      'POL': 'Politikk',
      'PSY': 'Psykologi',
      'REL': 'Religion og etikk',
      'KRL': 'KRLE',
      'TVE': 'Året rundt',
      'INF': 'Informasjonsteknologi',
      'SPA': 'Spansk',
      'TYS': 'Tysk',
      'FRA': 'Fransk',
      'GFG': 'Geofag',
      'KHV': 'Kunst og håndverk',
      'MUS': 'Musikk',
      'MHE': 'Mat og helse',
      'SOK': 'Sosialkunnskap',
      'SOS': 'Sosiologi og sosialantropologi',
      'POM': 'Politikk og menneskerettigheter',
      'SAK': 'Samfunnskunnskap',
      'SAG': 'Samfunnsgeografi ',
    },
    'language': {
      'title': 'Målform',
      'nb': 'Bokmål',
      'nn': 'Nynorsk',
    },
    'taskTypes': {
      'article': 'Artikkel',
      'video': 'Video',
      'audio': 'Lyd',
      'file': 'Fil',
      'document': 'Dokument',
      'task': 'Oppgave',
      'resource': 'Ressurs',
      'digitalbook': 'Digitalbok',
      'game': 'Spill',
    },
  },
  'organization': {
    'title': 'Velg en aktiv skole for din økt',
    'choose': 'Velg skole',
  },
  'filters': {
    'forTeacher': 'Til læreren',
    'content': 'Innhold',
    'emptyFilter': 'Tøm filter',
    'chooseTheme': 'Velg tema',
    'chooseTaskType': 'Velg innholdstype',
    'chooseSubject': 'Velg fag',
    'chooseGrade': 'Velg trinn',
    'chooseGroup': 'Velg gruppe',
    'chooseLanguage': 'Velg målform',
    'chooseFilters': 'Vis filtre',
    'chooseSorting': 'Velg sortering',
    'chooseProduct': 'Velg bok',
    'chooseWeekNumber': 'Velg uke',
    'noResourcesFound': 'Ingen ressurser funnet',
    'noProducts': 'Ingen bøker funnet',
    'noSubjects': 'Ingen fag funnet',
    'filteredAway': {
      'title': 'Fant ingen ressurser',
      'messageWithGrades': 'Du kan se innhold ved å bytte til følgende trinn:',
      'messageWithoutGrades': 'Prøv å endre på filtreringen, eller ta kontakt med kundeservice',
    },
    'subject': 'Fag',
    'grade': 'Trinn',
    'product': 'Bok',
    'header': 'Overskrift',
    'taskType': 'Innholdstype',
    'filterSettings': 'Visningsvalg',
    'sortSettings': 'Sorteringsvalg',
    'noHits': 'Oi! Ser ut som filteret ditt ikke har noen treff.',
    'trySomethingElse': 'Prøv andre kombinasjoner for å få flere resultater.',
    'frontpage': 'Forside {subjectName}',
    'settings': {
      'suggested': 'Foreslått rekkefølge',
      'alphabetical': 'Alfabetisk',
      'studentActivity': 'Siste elevaktivitet',
      'random': 'Tilfeldig sortering',
    },
    'values': {
      'allSubjects': 'Alle fag',
      'thisWeek': 'Denne uken',
      'wholeClass': 'Hele klassen',
      'week': {
        'previous': 'Forrige uke',
        'current': 'Denne uken',
        'next': 'Neste uke',
        'previousFourWeeks': 'Siste fire uker',
        'previousThreeMonths': 'Siste tre måneder',
        'fromSchoolYearStart': 'Siden skolestart',
        'yearplan': 'Se årsplan',
      },
    },
  },
  'favorite': {
    'save': 'Lagre favoritt',
  },
  'plans': {
    'plan': 'Plan',
    'plannedThisWeek': 'Planlagt denne uka',
    'allPlans': 'Alle planer',
    'allYears': 'Alle år',
  },
  'plan': {
    'title': 'Planlagt',
    'content': 'Planlagt innhold',
    'add': 'Legg i plan',
    'sharePlan': 'Knytt til gruppe',
    'copySelection': 'Kopieringsvalg',
    'copyYearPlan': 'Kopier plan',
    'deleteYearPlan': 'Slett plan',
    'copyYearPlanToGroup': 'Kopier ressurser',
    'copyYearPlanToGroupExplanation': 'Dette vil kopiere ressursene som er delt med {groupName} i {weekNumber} til en annen gruppe.',
    'chooseGroupToCopyTo': 'Velg gruppe å kopiere ressurser til',
    'noPlans': 'Fant ingen planlagte ressurser i {subject} i {weekNumber}',
    'goToResources': 'Gå til fagsiden for {subject}',
    'resourcesCopied': 'Ressursene ble kopiert til {groupName}',
  },
  'yearPlan': {
    'plural': 'Planer',
  },
  'learningPath': {
    'learningPathOverview': 'Åpne oversikt over læringsløp',
    'learningPathParts': '{partsCount} deler',
    'noResourcesFound': 'Fant ingen ressurser i læringsløpet',
  },
  'links': {
    'seeAll': 'Se alle',
    'viewTasks': 'Se ukens planlagte ({number})',
    'viewMoreTasks': 'Tilbake til fagside',
    'loadingTasks': 'Laster ukens planlagte',
  },
  'contentTypes': {
    'default': 'Ressurs',
    'folder': 'Mappe',
    'product': 'Produkt',
    'product_container': 'Oversikt',
    'product_article': 'Artikkel',
    'product_package': 'Innholdspakke',
    'product_header': 'Delnivå',
    'product_tailor': 'Ressurs',
    'product_part': 'Del',
    'product_colophon': 'Kolofon',
    'article': 'Artikkel',
    'learning_path': 'Læringsløp',
    'document': 'Dokument',
    'landing_page': 'Forside',
    'cloubi_content': 'Ressurs',
    'video': 'Video',
    'image': 'Bilde',
    'upload_video': 'Video',
    'activetextbook': 'Interaktiv bok',
    'drawing_tool': 'Tavleressurs',
    'file': 'Fil',
    'audio': 'Lyd',
    'svg': 'Bilde',
    'game_board': 'Spillbrett',
    'game_part': 'Øve',
    'form_writer': 'Skriveramme',
    'epub': 'E-bok',
    'link': 'Link',
    'literary_text': 'Litterær tekst',
    'peer_gynt': 'Spill',
    'upload_file': 'Opplasting',
    'book_reader': 'Bokleser',
    'presentation': 'Presentasjon',
    'flyt_task': 'Oppgave',
    'pdf_book': 'Digitalbok',
  },
  'sections': {
    'none': 'Mangler innhold til dine trinn og fag. Prøv å endre på innstillingene.',
    'teacherResources': 'Lærerressurser for {subject}, {grade}',
  },
  'activity': {
    'callout': {
      'noData': {
        'title': 'Fant ikke aktivitet',
        'message': 'Her klarte vi ikke finne aktivitet. Om du tror dette er feil kan du forsøke å laste siden på nytt.'
      },
    },
    'messages': {
      'studentActivity': 'Elevaktivitet',
      'activityForStudent': 'Aktivitet for {student}',
      'noAnswer': 'Finner ikke besvarelse',
      'progressText': '{filledFields} av {totalFields}',
    },
    'status': {
      'visited': 'Besøkt',
      'notStarted': 'Ikke påbegynt',
    },
    'button': {
      'toAssignment': 'Vis mer',
      'openActivity': 'Vis aktivitet for ressurs {title}'
    },
  },
  'planner': {
    'addToWeek': {
      'title': 'Legg til i uke',
      'planTitle': 'Tema for {week} {year}',
      'notCreated': 'Ressursen ble ikke lagt til',
      'noGroup': 'Velg en aktiv gruppe, øverst på siden, for å planlegge',
      'noGroupShort': 'Velg en gruppe',
      'noYearPlan': 'Ingen plan funnet for denne ressursen',
      'noWeek': 'Uka ble ikke funnet i planen',
      'noRemove': 'Mangler tilgang',
      'removed': 'Ressursen ble fjernet',
      'failed': 'Noe gikk galt. Prøv igjen senere',
      'pastWeek': 'Kan ikke planlegge bakover i tid',
    },
    'selectYearPlanDialog': {
      'title': 'Velg hvilken årsplan vi skal bruke',
      'description': 'Du har flere årsplaner for denne gruppa. På grunn av det får du nå velge hvilken vi skal bruke, eller om vi skal opprette en ny.',
    },
    'selectGradeDialog': {
      'title': 'Velg trinn',
      'description': 'Velg et trinn for denne gruppa: «{group}»',
      'explanation': 'For å kunne lagre og hente ut informasjon riktig må vi ha et trinn for denne gruppa. Siden det ikke går an å hente det ut automatisk må du oppgi det her.',
    },
    'selectWeekNumberDialog': {
      'selectWeek': 'Velg uke',
      'title': 'Planlegg ressurs',
    },
    'addResource': {
      'error': 'Fikk ikke lagt ressursen til i uka',
      'success': 'Ressursen ble lagt til i uke {weekNumber}',
      'resourceInWeeks': 'Ressursen «{resourceTitle}» finnes allerede i følgende uker:',
      'addToWeek': 'Legg til ressurs i uke {weekNumber}',
      'removeFromWeek': 'Fjern ressurs fra uke {weekNumber}',
      'addedToWeek': 'Lagt til i uke',
      'alreadyPlanned': 'Allerede planlagt',
      'moreWeeks': 'Vis alle uker',
    },
    'createYearPlan': {
      'title': 'Planlegger',
      'body': 'Velg hvor du vil planlegge denne ressursen',
      'missingOrganizationOrGroups': 'Uten grupper kan du ikke planlegge',
      'missingActiveGroup': 'Velg en aktiv gruppe først',
      'missingSubject': 'Velg et fag å planlegge i',
      'missingGrade': 'Velg et trinn å planlegge i',
      'missingWeekNumber': 'Mangler uke å planlegge i',
      'save': 'Lagre plan',
      'saveDisabledTooltip': 'Det er noe informasjon som mangler, og da kan vi ikke lagre',
    },
    'createResource': {
      'title': 'Del egen ressurs',
      'upload': 'Del en fil',
      'url': 'URL',
      'shareUrl': 'Del en URL',
      'save': 'Lagre ressurs',
      'isUploading': 'Laster...',
      'editFileName': 'Rediger navn på ressursen',
      'missingFileName': 'Mangler filnavn',
      'fileNamePlaceholder': 'Skriv et navn...',
      'maxFileSize': 'Maks filstørrelse: {mb}MB',
      'dragAndDrop': 'Dra og slipp en fil fra skrivebordet eller <strong>trykk her</strong>',
      'fileIsTooLargeTitle': 'For stor fil',
      'fileIsTooLargeText': 'Denne filen er for stor! Vi har en maks filstørrelse på {mb}MB. Kan du velge en mindre fil?',
      'missingResource': 'Ingen ressurs er opprettet',
      'downloadError': 'Filen ble ikke funnet',
      'unknownError': 'Noe gikk galt dessverre. Prøv igjen senere.',
      'linkError': 'Lenken er ikke gyldig. Prøv igjen.',
      'linkTest': 'Test at lenka fungerer',
      'linkPlaceholder': 'Lim inn URLen her',
      'created': 'Ressursen ble opprettet og delt i uke {weekNumber}',
      'unable': 'Velg en aktiv gruppe i toppmenyen',
    },
    'suggestedYearPlans': {
      'title': 'Foreslåtte planer',
      'description': 'Her er Aschehougs foreslåtte planer, klare for kopiering ut i uker.',
      'filteredByActiveGroup': 'Viser planer for {grade}, som er trinnet som er satt for den aktive gruppen «{group}». Fagene er de samme som i innstillingene dine.',
      'filteredBySettings': 'Planene er filtrert på fag og trinn fra innstillingene dine.',
      'showAll': 'Vis alle foreslåtte planer',
      'noYearPlansForYou': 'Vi har ingen planer for de fag og trinn du har valgt. Derfor viser vi deg alle planene vi har.',
    },
    'copyYearPlan': {
      'title': 'Kopierer plan: { title }',
      'body': 'Velg hvor du vil kopiere denne planen',
      'activatePreSharing': 'Del ukeplaner til elevene dine uken før de er planlagt',
      'displayToColleagues': 'Gjør planen synlig for dine kolleger',
      'displayToColleaguesNote': 'Dine kolleger vil kunne se planens navn og temaer. De kan ikke åpne planen, men be deg om tilgang til den.',
      'every': 'Hver',
      'showMore': 'Vis {howMany} flere årsplaner',
      'confirmSameTitle': 'Planen har samme navn',
      'titleNotChanged': 'Du har ikke endret tittelen på årsplanen. Vil du likevel kopiere den?',
      'copy': 'Kopier!',
      'cancel': 'Vent litt …',
      'goToPreview': 'Forhåndsvis plan',
      'placeholders': {
        'chooseGroup': 'Velg gruppe',
        'chooseSchoolYear': 'Velg skoleår',
        'chooseGrade': 'Velg trinn',
        'chooseSubject': 'Velg fag',
      },
      'errors': {
        'noTitle': 'Du må velge en tittel',
        'noSchoolYear': 'Du må velge et skoleår',
        'noGrade': 'Du må velge et trinn',
        'noGroup': 'Du må velge en gruppe',
        'noSubject': 'Du må velge et fag',
        'groupSubjectAndGradeDoesNotMatch': 'Gruppens fag og trinn ({subject}, {grade}) er ulikt det som er valgt for denne planen. Har du valgt riktig gruppe?',
        'yearPlanSubjectAndGradeDoesNotMatch': 'Planens foreslåtte fag og trinn er ulikt det som er valgt. Har du valgt riktig plan?',
      },
      'preview': {
        'yearPlanDialog': 'Forhåndsviser planen «{planTitle}» før kopiering',
        'explanation': 'Dette er en forhåndsvisning av hvordan denne planen ser ut. Ressursene har blitt fordelt ut over uker gjennom skoleåret.',
        'moveToWeek': 'Flytt',
        'moveToWeekNumber': 'Uke {weekNumber}',
        'plannedInWeek': 'Uke {weekNumber}',
        'copy': 'Kopier',
        'cancel': 'Avbryt',
        'missingResources': 'Ingen foreslåtte ressurser denne uka.',
        'duration': 'Uke {fromWeek} – Uke {toWeek}',
      },
      'copyYearPlanDialog': {
        'labels': {
          'title': 'Tittel',
          'group': 'Gruppe',
          'grade': 'Trinn',
          'subject': 'Fag',
        },
        'planCopied': 'Planen «{title}» er kopiert! Den er merket med {grade} og {subject}.',
        'planShared': 'Planen har blitt delt med gruppa {groupName}, og ressursene blir vist til elevene.',
        'resourcesAppear': 'Du kan nå gå til fagsiden for {subject} og se at ressursene dukker opp i riktige uker.',
        'openSubjectPage': 'Se oppgaver for {subject}',
      },
    },
  },
  'dialog': {
    'confirm': 'OK',
    'cancel': 'Avbryt',
    'choose': 'Velg',
    'create': 'Opprett ny',
    'add': 'Legg til',
  },
  'copy': {
    'copyUrl': 'Kopier lenke',
    'copyTemplate': {
      'title': 'Uke {weekNumber}',
    },
    'messages': {
      'success': 'Kopiert',
      'error': 'Kunne ikke kopiere',
    },
  },
  'footer': {
    'customerService': 'Kundeservice',
    'exam': 'Eksamen',
    'privacy': 'Personvern',
    'accessibility': 'Universell utforming',
    'webshop': 'Nettbutikk',
    'copyright': 'Rettigheter',
    'cookies': 'Cookies',
  },
  'trial': {
    'title': 'Velkommen!',
    'message': 'Her finner du innhold til alle fag og alle trinn. <a href="{href}" target="_blank">Bestill en gratis prøvelisens</a> til vårt utforskende læringsunivers. God lærelyst!',
    'noHits': 'Husk at du kan <a href="{href}" target="_blank">bestille en gratis prøvelisens</a> til vårt utforskende læringsunivers.',
  },
  'license': {
    'message': 'Lisensdetaljer for {name}',
    'ean': 'ISBN',
    'licenseModel': 'Type',
    'endDate': 'Gyldig til',
    'orderId': 'Ordrenr',
    'usageRights': 'Antall',
    'noLicenses': {
      'title': 'Fant ingen lisenser',
      'message': 'Om du tror dette er en feil kan du forsøke å laste inn siden på nytt eller kontakte kundestøtte.'
    }
  },
  'licenseModel': {
    'OPEN': 'Åpen lisens',
    'SCHOOL': 'Skolelisens',
    'INDIVIDUAL': 'Enkeltlisens',
    'PRIVATE': 'Privatlisens',
    'TRIAL_SCHOOL': 'Prøvelisens, skole'
  },
  'colophon': {
    'title': 'Kolofoner i {subject}',
    'plural': 'Kolofoner',
    'back': 'Tilbake til fagside',
  },
  'search': {
    'title': 'Søk',
    'placeholder': 'Søk her...',
    'lookingFor': 'Søk innenfor {filters}...',
    'globalSearch': 'Søk i hele Aunivers',
    'resultsCount' : '{count} treff',
    'currentPage': 'Side {page} av {totalPages}',
    'noResults': 'Ingen resultater funnet',
    'noResultsDescription': 'Fant ingen søkeresultater som samsvarer med søkeordet eller filtrene dine. Fjern noen filtre eller nullstill søket.',
    'searchingIn': 'Søker i {in}',
    'loadingProducts': 'Stiller inn søket',
    'failed': 'Noe gikk galt',
    'reset': 'Nullstill',
    'resetSearch': 'Start på nytt',
    'resetFilters': 'Fjern alle filtre',
    'contentTypes': 'Innholdstyper',
    'animationLabel': 'Animert illustrasjon som illustrerer et søk',
    'popularSearches': 'Populære søkeord',
    'settings': {
      'mySettings': 'Mine søkeinnstillinger',
      'grade': 'Trinninnstillinger',
      'results': 'Du får resultater basert på disse bøkene',
      'editMessage': 'Du kan redigere trinnene dine i <b>Innstillinger > Trinn og fag</b>',
    },
    'lockedContent': {
      'noAccess': 'Du har ikke tilgang til dette innholdet',
      'goToWebshop': 'Gå til nettbutikken',
      'relatedProduct': 'Dette innholdet hører til produktet <b>{product}</b>.',
      'unknownProduct': 'Dette innholdet hører til et produkt som er lisensbelagt.',
      'find': 'Du finner produktet i vår nettbutikk.',
    },
    'paginator': {
      'page': 'Side {page}',
      'nextPage': 'Neste side',
      'prevPage': 'Forrige side',
      'navigation': 'Sidenavigering',
    },
    'filters': {
      'showGradeFilter': 'Vis trinnfiltre',
      'hideGradeFilter': 'Skjul trinnfiltre',
      'showSubjectFilter': 'Vis fagfiltre',
      'hideSubjectFilter': 'Skjul fagfiltre',
      'activeFilters': 'Aktive filtre',
      'removeFilter': 'Fjern {filter} som filter',
      'removeAllFilters': 'Fjern alle filtre',
      'filterBySubject': 'Filtrer på fag',
    }
  },
  'register': {
    'form': {
      'title': 'Registrer ny bruker',
      'intro': 'For å bruke digitale læremidler på Aunivers.no/unibok.no må du registrere deg.',
      'submit': 'Registrer',
    },
    'input': {
      'firstName': 'Fornavn',
      'lastName': 'Etternavn',
      'email': 'E-postadresse',
      'password': 'Ditt passord',
      'terms': 'Jeg har lest, forstått og akseptert <a href="{url}" class="underline" target="_blank">brukervilkårene</a>'
    },
    'invalid': {
      'firstName': 'Fornavn er ikke gyldig',
      'lastName': 'Etternavn er ikke gyldig',
      'email': 'E-postadressen er ikke gyldig',
      'password': 'Passordet er ikke gyldig',
    },
    'error': {
      'internal': 'Noe gikk galt ved registrering av brukeren. Vennligst prøv på nytt om en liten stund.',
      'loggedIn': 'Du kan ikke registrere en bruker når du allerede er logget inn',
      'invalidInput': 'Feil ved validering av dataene dine. Se over og prøv på nytt',
      'alreadyExists': 'En bruker med samme e-postadresse eksisterer allerede',
      'missingParams': 'Mangler nødvendig aktiveringskode',
      'activate': 'Noe gikk galt ved aktivering av kontoen din',
    },
    'success': {
      'title': 'Vellykket registrering!',
      'info': 'Brukeren din er registrert, men må bekreftes først. Dette må du gjøre nå:',
      'confirm1': 'Åpne e-posten du har fått',
      'confirm2': 'Klikk på lenken <b>innen to dager</b> for å aktivere brukeren din',
    },
    'activate': {
      'title': 'Aktivering',
      'info': 'Lag et passord til brukeren din. Oppgi minst åtte tegn, inkludert minst ett tall.',
      'inputText': 'Vis i klartekst',
      'inputPassword': 'Skjul tekst',
      'success': 'Passordet er lagret. Du kan nå logge inn.',
    },
  },
  'labels': {
    'product_article': 'Produktartikkel',
    'learning_path': 'Læringsløp',
    'file': 'Fil',
    'product_part': 'Del av løp',
    'video': 'Video',
    'article': 'Artikkel',
    'task': 'Oppgave',
    'resource': 'Ressurs',
    'digitalbook': 'Digitalbok',
    'audio': 'Lyd',
    'part': 'Del av løp',
    'game': 'Spill',
    'document': 'Dokument',
    'book_reader': 'Bokleser',
    'presentation': 'Presentasjon',
  },
  'access': {
    'title': 'Tilgang',
    'public': 'Åpen for alle',
    'teacher': 'Kun for lærer',
  },
  'blog': {
    'title': 'Siste nytt i Aunivers',
    'shortTitle': 'Nyheter',
    'noPosts': 'Her var det tomt!',
    'seAllPosts': 'Se alle nyhetssaker',
    'subpages': {
      'all': 'Alle',
      'news': 'Nyheter',
      'inspiration': 'Inspirasjon',
    }
  },
  'mimeType': {
    'pdf': 'PDF',
    'word': 'Word',
    'excel': 'Regneark',
    'video': 'Video',
    'audio': 'Lydfil',
    'image': 'Bilde',
    'powerpoint': 'Presentasjon',
    'archive': 'Arkiv',
    'file': 'Fil',
  },
  'bookreader': {
    'error': 'Kunne ikke laste inn bokleser',
    'loading': 'Laster inn bokleser',
    'readBook': 'Les bok',
  },
  'content': {
    'published': 'Utgitt',
    'language': 'Språk',
    'pageCount': 'Antall sider',
    'audio': 'Lyd',
    'recordedAudio': 'Innlest lyd',
    'inSeries': 'Inngår i serie',
  },
  'presentation': {
    'page': 'Side',
    'pageNumber': 'Side {pageNumber}',
    'pageNumberOfTotal': 'Side {pageNumber} / {totalPages}',
    'teacherGuide': 'Lærerveiledning',
    'menu': {
      'menu': 'Meny',
      'content': 'Innhold',
      'contentOverview': 'Innholdsoversikt',
      'openTeacherGuide': 'Åpne lærerveiledning',
      'teacherGuideDescription': 'Få tilhørende materiell til presentasjonen og informasjon om hvordan å bruke dette læreverket.',
      'tips': 'Tips',
      'guideOne': 'Bruk piltasten høyre',
      'guideTwo': 'for å navigere fremover i presentasjonen. Bruk piltasten venstre',
      'guideThree': 'for å navigere bakover i presentasjonen.',
    },
  },
  'media': {
    'playAudio': 'Spill av lyd',
    'pauseAudio': 'Pause lyd',
    'closeAudio': 'Lukk lyd'
  },
  'lottie': {
    'play': 'Spill av animasjon',
    'pause': 'Pause animasjon',
  },
  'licenseControl': {
    'message': {
      'title': 'Oisann! Du har ikke tilgang til dette innholdet',
      'body': {
        'teacher': 'Vi klarte ikke å finne en gyldig lisens på dette innholdet. Om du mener dette er en feil, kontakt kundestøtte for hjelp',
        'student': 'Spør læreren din om hjelp',
      }
    },
    'buttons': {
      'back': 'Tilbake',
      'webshop': 'Til nettbutikk',
    },
  }
}
